import Vue from "vue";
import VueRouter from "vue-router";
import { isMobile } from "@/utils/utils";
import store from "../store/index";
import { routes } from "./routes";

Vue.use(VueRouter);

const addTrackPvLog = (to) => {
  setTimeout(() => {
    try {
      const userInfo = localStorage.getItem("userInfo") ? JSON.parse(localStorage.getItem("userInfo")) : {};
      console.log("userInfo---->", userInfo);
      const { id = "", name = "" } = userInfo;
      if (window.track) {
        if (id && name) {
          window.track.setUserId(`${id}|${name}`);
        }
        window.track._pvTrack(to.meta?.title || to.query?.title || document.title);
      }
    } catch (error) {
      console.error(error);
    }
  });
};

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});

let isInit = false;

router.beforeEach((to, from, next) => {
  if (!isInit && document.referrer.indexOf("google") !== -1) {
    isInit = true;
    next({
      path: "/",
    });
    return;
  }
  console.log("beforeEach to--->", to);

  // 开发环境：跳过移动端逻辑，但继续执行后面的登录校验
  if (process.env.NODE_ENV === "development") {
    // 不 return，直接跳过移动端逻辑
  } else {
    // 生产环境才做移动端跳转
    if (isMobile()) {
      const mobileDomain = process.env.VUE_APP_MOBILE_DOMAIN;
      const targetPath = to?.meta?.mobilePath || "/";
      const query = to.query;
      const queryParams = new URLSearchParams({ ...query });
      const redirectUrl = `${mobileDomain}${targetPath}?${queryParams.toString()}`;
      window.location.href = redirectUrl;
      return; // 阻止后续逻辑
    }
  }

  // 登录校验（开发 / 生产都会执行）
  // const isLogin = store.state.base.isLogin;
  // if (to.meta.requireLogin && !isLogin) {
  //   store.commit("base/SET_SHOWLOGIN", true);
  //   store.commit("base/SET_LOGINTO", to.fullPath);
  // return; // 阻止跳转
  // }
  next();
});

router.afterEach((to) => {
  console.log("afterEach----->", to.fullPath);
  addTrackPvLog(to);
  store.commit("base/SET_REDIRECT_PATH", to.fullPath);
  // const pushTrack = initNuxtTrack("official-br");
  // pushTrack({
  //   pageTitle: to.meta.title || "未配置页面title",
  //   moduleName: "巴西官网",
  //   routeName: to.path,
  // });
});

export default router;
